import { useEffect, useState } from "react";
import { array, object, string } from "prop-types";

import $ from "jquery";

import CountryInfo from "./CountryInfo.jsx";

import home_worldmap from "./legacy/home_worldmap.js";

const propTypes = {
  comparePageURL: string,
  homeWorldmapData: array.isRequired,
  dictionaryData: object.isRequired,
};

const MapAndInfo = (props) => {
  const { comparePageURL, homeWorldmapData, dictionaryData } = props;

  const [countryData, updateCountryData] = useState(null);

  const [resetFn, setResetFn] = useState(null);

  useEffect(() => {
    const { resetMap } = home_worldmap({
      home_worldmap_data: homeWorldmapData,
      dictionaryData,
      showCountryInfo: updateCountryData,
    });
    setResetFn(() => resetMap);
  }, [dictionaryData, homeWorldmapData]);

  // Note: Newsletter Modal needs to be rendered on page load so validation scripts can find it (March 2020);

  return (
    <>
      <div className="homepage-map__svg-container js-homepage-map-svg"></div>
      <CountryInfo
        comparePageURL={comparePageURL}
        selectedState={countryData}
        dictionaryData={dictionaryData}
        homeWorldmapData={homeWorldmapData}
        onClose={() => {
          updateCountryData(null);
          resetFn(true);
          $(".disclaimer-container").show();
        }}
      />
    </>
  );
};

MapAndInfo.propTypes = propTypes;
export default MapAndInfo;
